import React from 'react';

import UserRouter from './app/router';

const NewUserDashboard: React.FC = () => {
    return (
        <UserRouter />
    );
};

export default NewUserDashboard;
